import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Footer from "@/components/Footer";
import SkipLink from "@/components/SkipLink";
import SEOHead from "@/components/SEOHead";
import Analytics from "@/components/Analytics";
import StructuredData from "@/components/StructuredData";
import CookieConsent from "@/components/CookieConsent";
import AccessibilityEnhancements from "@/components/AccessibilityEnhancements";
import TechCarousel from "@/components/TechCarousel";
import ClientLogos from "@/components/ClientLogos";
import PositioningStatement from "@/components/PositioningStatement";
import Certifications from "@/components/Certifications";
import Contact from "@/components/Contact";
import { useSEO, useCoreWebVitals } from "@/hooks/useSEO";
import { initPerformanceOptimizations } from "@/utils/performanceOptimizations";
import TrustedClients from "@/components/TrustedClients";

const Index = () => {
  // SEO optimization for homepage
  useSEO({
    title: "Smartborn - Enterprise AI & IT Services | 100+ Projects Delivered",
    description:
      "Transform your business with enterprise-grade AI & IT services. Custom software, cloud solutions, offshore development. 200+ expert developers, 15+ years experience across 25+ industries.",
    keywords:
      "enterprise AI development, custom software development, IT consulting services, offshore software development, staff augmentation services, cloud migration solutions, digital transformation, SAP consulting, Salesforce implementation, Workday HCM, cybersecurity services, DevOps automation, mobile app development, machine learning solutions, data analytics, API development",
    canonical: "https://smartborn.io/",
    ogImage:
      "https://smartborn.io/lovable-uploads/191658a8-ce44-4edc-a729-a8d8b92a2d8b.png",
    ogType: "website",
  });

  // Track Core Web Vitals for performance monitoring
  useCoreWebVitals();

  // Initialize performance optimizations
  useEffect(() => {
    initPerformanceOptimizations();
  }, []);

  return (
    <>
      <Analytics />
      <StructuredData type="organization" />
      <StructuredData type="website" />
      <AccessibilityEnhancements />

      <div className="min-h-screen">
        <SEOHead />
        <SkipLink />
        <Navigation />
        <main id="main-content" tabIndex={-1}>
          <Hero />

          <TrustedClients />
          <PositioningStatement />
          {/* <Services /> */}
          <TechCarousel />
          <ClientLogos />
          <Certifications />
          <Contact />
        </main>
        <Footer />
        <CookieConsent />
      </div>
    </>
  );
};

export default Index;
